<div fxFlex fxLayout="column">
  <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
    <strong *ngIf="isOpenNow$ | async; else closedEl">
      {{ 'appointment-schedule.location.hours.open' | translate }}
    </strong>
    <ng-template #closedEl>
      <strong>
        {{ 'appointment-schedule.location.hours.closed' | translate }}
      </strong>
    </ng-template>

    <span fxFlex>
      {{ openingOrClosingTime$ | async }}
    </span>

    <button mat-icon-button (click)="toggleExpand($event)">
      <mat-icon *ngIf="(expanded$ | async) === false; else expandLessEl">expand_more</mat-icon>
      <ng-template #expandLessEl>
        <mat-icon>expand_less</mat-icon>
      </ng-template>
    </button>
  </div>

  <div *ngIf="expanded$ | async" fxFlex fxLayoutAlign="start start">
    <ul>
      <li *ngFor="let hours of formattedWorkingHours$ | async">
        <span class="weekday">{{ hours.day }}</span>
        <ng-container *ngIf="hours.isClosed">
          <span>{{ 'appointment-schedule.location.hours.closed' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="!hours.isClosed && hours.openAt && hours.closeAt">
          <span>{{ hours.openAt }} - {{ hours.closeAt }}</span>
        </ng-container>
      </li>
    </ul>
  </div>
</div>
